module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("3Thr9"))).then(() => parcelRequire('caIQj'));